import config from '../config';

import { oktaAuth } from './service-calls/reusable';

module.exports = () => {
  config();
  oktaAuth();
};
